import Rfa from 'domain/rfa';
import User from 'domain/user';

class RfaPermissions {
  canViewDeleted = (user, _project) => User.isAdmin(user);

  canSubmit = (user, project) => User.isAdminOrProjectSubscriber(user, project);

  canEdit = (user, project, rfa) =>
    User.isAdminOrProjectSubscriber(user, project) &&
    (Rfa.isDraft(rfa) || !Rfa.isClosed(rfa));

  canEmail = (_user, _project, rfa) => !Rfa.isDeleted(rfa);

  canVoid = (user, _project, rfa) => {
    if (rfa.voided_at) return false;
    const isCreator = rfa.created_by && rfa.created_by.id === user.id;
    return User.isAdmin(user) || isCreator;
  };

  canUnvoid = (user, _project, rfa) => {
    if (!rfa.voided_at) return false;
    const isCreator = rfa.created_by && rfa.created_by.id === user.id;
    return User.isAdmin(user) || isCreator;
  };

  canDelete = (user, project, rfa) => {
    if (Rfa.isDeleted(rfa)) return false;

    if (User.isAdmin(user)) return true;

    // Drafts may be created by the agent service account, so allow any
    // project subscriber to delete them (same rule as canEdit for drafts).
    if (Rfa.isDraft(rfa)) return User.isAdminOrProjectSubscriber(user, project);

    if (Rfa.isPending(rfa)) return User.isSameCompany(user, rfa.created_by);

    return false;
  };
  canReviewPRfa = (user, project, rfa) => {
    return (
      rfa &&
      rfa.id &&
      rfa.assigned_to &&
      rfa.assigned_to_id !== user.id &&
      User.isAdminOrProjectSubscriber(user, project) &&
      (rfa.status === 'pending' || rfa.status === 'draft_pending')
    );
  };
  canRevise = (user, project, rfa) => {
    if (rfa.revised) return false;

    return (
      (Rfa.isPending(rfa) &&
        (User.isAdmin(user) ||
          User.isSameCompany(user, rfa.created_by) ||
          User.isSameCompany(user, rfa.reviewed_by))) ||
      (Rfa.isClosed(rfa) &&
        (User.isSameCompany(user, rfa.created_by) ||
          this.canSubmit(user, project)))
    );
  };
}

export default new RfaPermissions();
